// The page the template editor previews: one element of the template's kind,
// pointed at something real.
//
// A template on its own renders nothing — the composer wants a page, and the
// blog element wants a post, a listing or a collection behind it. So the editor
// composes the smallest page that has one, the way the section editor composes
// a one-element page (../../../../sections/section/edit/preview): a `blog-post`
// element with the newest published post's slug as the route param, a
// `blog-list` on page 1, a `blog-post-collection` on the first collection the
// site has. Nothing to save here; the page exists for the frame and the data
// that reaches it comes from the same fetch the page editor's frame uses.
//
// Pure — the sample is CHOSEN from what the caller loaded, so a suite can pin
// which post the preview shows without a client. ./frame does the loading.
import { TEMPLATE_TYPES } from "../../kinds";

const FRAME = "<div><%-content%></div>";

// The route each sample page sits on. `/blog/:slug` and `/blog/:slug` again
// for the listing's `postRoute`, so the items' links read as the convention
// the element screens describe; the page number sits under a literal
// segment for the reason docs/pagews-blog.md §4 gives.
const ROUTES = {
  post: "/blog/:slug",
  list: "/blog/page/:page?",
  collection: "/blog",
};

const POST_ROUTE = "/blog/:slug";

const configOf = (kind, { slug = "", collectionId = "" } = {}) => {
  if (kind === "post") {
    return { slug: "{{params.slug}}" };
  }

  if (kind === "list") {
    return { limit: 10, tag: "", postRoute: POST_ROUTE };
  }

  return { collectionId, postRoute: POST_ROUTE };
};

// `newest` is the first item of page 1 of the published listing, or null;
// `collection` the first collection the site lists, or null. Either absent is a
// page whose element says "not found" in place — which is what the template
// shows on a site with nothing published yet, and is right.
export const samplePage = (kind, { newest = null, collection = null } = {}) => {
  const slug = (newest && newest.slug) || "";
  const collectionId = (collection && collection.collectionId) || "";

  return {
    page: {
      pageId: `blog-template-${kind}`,
      title: "Template preview",
      route: ROUTES[kind] || "/blog",
      elements: [
        {
          elementid: "template",
          name: "template",
          type: TEMPLATE_TYPES[kind],
          tags: [],
          frame: FRAME,
          config: configOf(kind, { slug, collectionId }),
        },
      ],
    },
    // What `{{params.slug}}` resolves to, the way the page editor's Editor
    // tab params do. The listing previews page 1, which is the route without
    // its param.
    params: kind === "post" ? { slug } : {},
  };
};
